export enum NavMenuItemsPosition {
  MAIN = "MAIN",
  SECONDARY = "SECONDARY",
}
